// extracted by mini-css-extract-plugin
export default {"ModalWrapper":"modal_ModalWrapper__xZHpt","Modal":"modal_Modal__-GOTU","Shown":"modal_Shown__yosl-","Active":"modal_Active__PBQUJ"};